/* eslint-disable i18next/no-literal-string */
import { Box, Link, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TablePaginationProps } from "../../common/components/functional/pagination/types";
import TablePaginationComponent from "../../common/components/functional/pagination/TablePaginationComponent";

type Props = {
  pagination?: TablePaginationProps;
  isLoading: boolean;
};

export const SalariesHeader = ({ isLoading, pagination }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography
          fontSize={14}
          fontWeight={700}
          textTransform={"uppercase"}
          variant="header"
        >
          {t("common:searchResults")}
        </Typography>
        {!isLoading ? (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Link
              sx={{
                fontSize: 12,
                marginRight: 3,
                fontWeight: 600,
                cursor: "pointer",
                color: "magenta",
              }}
            >
              Lataa hakutulokset taulukkomuodossa
            </Link>
            {pagination && (
              <TablePaginationComponent
                count={pagination.count}
                pageIndex={pagination.pageIndex}
                pageSize={pagination.pageSize}
                onPageChange={pagination.onPageChange}
                wrapInRow={false}
              />
            )}
          </Box>
        ) : null}
      </Box>
    </>
  );
};
